import { DEFAULT_BRANCH_FORMAT } from './types'

/** Lowercase, git-safe slug of free text (mirrors the bridge's slugify). */
function slugify(text: string, max = 40): string {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, max)
    .replace(/-+$/g, '')
}

/** Legacy resolvable shape `super-agent/<slug>-<guid>` — used when a format needs an absent identifier. */
function legacyBranch(taskId: string, taskName: string): string {
  const slug = slugify(taskName)
  const id = taskId.replace(/[^a-zA-Z0-9]+/g, '')
  return slug ? `super-agent/${slug}-${id}` : `super-agent/${id}`
}

/**
 * Render a branch name from the configurable template — the frontend twin of the bridge's
 * `buildBranchName`, so the copy-branch button matches what the Super Agent produces and what the
 * webhook resolver links. Falls back to the legacy shape when the format needs an absent identifier.
 */
export function renderBranchName(
  args: { taskId: string; taskName: string; identifier?: string | null },
  format: string = DEFAULT_BRANCH_FORMAT,
): string {
  const { taskId, taskName, identifier } = args
  if (format.includes('{identifier}') && !identifier) return legacyBranch(taskId, taskName)

  const id = taskId.replace(/[^a-zA-Z0-9]+/g, '')
  const rendered = format
    .replace(/\{identifier\}/g, identifier ?? id)
    .replace(/\{title\}/g, slugify(taskName))
    .replace(/\{id\}/g, id)
    .replace(/\{username\}/g, 'moly')
  const cleaned = rendered
    .replace(/[^a-zA-Z0-9/_-]+/g, '-')
    .replace(/-{2,}/g, '-')
    .replace(/\/{2,}/g, '/')
    .replace(/(^[-/]+|[-/]+$)/g, '')
  return cleaned || legacyBranch(taskId, taskName)
}
